import { TPromotionIdentifier } from 'core/model/interfaces/promotions';
import { https } from 'shared/utils/https';
import type {
  IPromotionDetailRequestDTO,
  IPromotionDetailResponseDTO,
  IPromotionDTO,
  IPromotionListResponseDTO,
  IPromotionParamsDTO,
} from './promotions.dto';

const promotionEntitiesBaseURL = '/v1';

export const promotionsData = {
  getPromotionSummaryList: async (): Promise<Array<IPromotionDTO>> => {
    const url = `${promotionEntitiesBaseURL}/promotions/summary`;
    const { data } = await https.get<Array<IPromotionDTO>>(url);
    return data;
  },
  getPromotionList: async (params: IPromotionParamsDTO): Promise<IPromotionListResponseDTO> => {
    const url = `${promotionEntitiesBaseURL}/promotions`;
    const { data } = await https.get<IPromotionListResponseDTO>(url, { params });
    return data;
  },
  getPromotionDetail: async ({ id, sourceId }: TPromotionIdentifier): Promise<IPromotionDetailResponseDTO> => {
    const url = `${promotionEntitiesBaseURL}/promotions/${id}`;
    const { data } = await https.get<IPromotionDetailResponseDTO>(url, { headers: { 'Gtm-Source-Id': sourceId } });
    return data;
  },
  updatePromotion: async ({ id, sourceId }: TPromotionIdentifier, body: IPromotionDetailRequestDTO): Promise<void> => {
    const url = `${promotionEntitiesBaseURL}/promotions/${id}`;
    await https.patch<IPromotionDetailResponseDTO>(url, body, { headers: { 'Gtm-Source-Id': sourceId } });
  },
};
